import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.graphData.loading;
export const selectErrorMessage = (state: RootState) => state.graphData.error;
export const graphDataResponse = (state: RootState) =>
  state.graphData.graphDataResponse;
